import React from 'react';
import { AutoSuggest, Props } from '.';
import { FieldRenderProps } from 'react-final-form';

export default function AutoSuggestFormWrapper(
  props: FieldRenderProps<Props, HTMLInputElement> & Props,
) {
  const { input, meta, ...rest } = props;
  return (
    <AutoSuggest
      {...input}
      onBlur={() => input.onBlur()}
      touched={meta.touched}
      error={meta.error}
      {...rest}
    />
  );
}
